import {createFilledFromStrokeSVG, createStrokeSVG} from './TEMPLATE'

// tabler: hash
export const HashtagWide_Stroke1_Corner0_Rounded = createStrokeSVG({
  paths: ['M5 9l14 0', 'M5 15l14 0', 'M11 4l-4 16', 'M17 4l-4 16'],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})

// tabler: hash — filled variant generated from the outline (auto-B)
export const Hashtag_Filled_Corner0_Rounded = createFilledFromStrokeSVG({
  path: 'M5 9l14 0 M5 15l14 0 M11 4l-4 16 M17 4l-4 16',
  viewBox: '0 0 24 24',
  strokeWidth: 3,
})

// tabler: hash
export const Hashtag_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M5 9l14 0', 'M5 15l14 0', 'M11 4l-4 16', 'M17 4l-4 16'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
